import { CheckCircleIcon, formatNumber, XMarkIcon } from "@";

type Props = {
  totalItems: number;
  selectedIds: number[];
  selectingAll: boolean;
  clearSelection: () => void;
  setSelectingAll: (value: boolean) => void;
};

const BulkSelection = ({
  selectedIds,
  totalItems,
  selectingAll,
  clearSelection,
  setSelectingAll,
}: Props) => {
  const count = selectingAll ? totalItems : selectedIds.length;

  return (
    <div className="relative mt-5 flex flex-wrap items-center justify-between gap-3 overflow-hidden rounded-2xl border border-purple-100 bg-gradient-to-l from-purple-50/40 via-white to-purple-50/30 p-3 dark:border-purple-800/40 dark:from-purple-950/30 dark:via-gray-800 dark:to-purple-950/20">
      {/* Decorative orb */}
      <span
        aria-hidden
        className="pointer-events-none absolute -end-10 -top-10 h-28 w-28 rounded-full bg-gradient-to-br from-purple-200/40 to-transparent blur-2xl dark:from-purple-700/30"
      />

      <div className="relative flex items-center gap-3">
        <span className="flex h-10 w-10 items-center justify-center rounded-2xl bg-gradient-to-br from-purple-800 to-purple-950 text-white shadow-md shadow-purple-900/25 ring-1 ring-purple-900/10 dark:from-purple-600 dark:to-purple-800">
          <CheckCircleIcon className="h-5 w-5" />
        </span>
        <p className="text-[15px] tracking-tight text-gray-700 dark:text-gray-300">
          تم اختيار
          <span className="mx-1.5 inline-flex items-center rounded-full bg-purple-100 px-2 py-0.5 text-sm font-bold tabular-nums text-purple-900 ring-1 ring-purple-200 dark:bg-purple-950/50 dark:text-purple-300 dark:ring-purple-800/40">
            {formatNumber(count)}
          </span>
          سجل
        </p>
      </div>

      <button
        type="button"
        className="group/bulk relative inline-flex items-center gap-2 rounded-2xl border border-purple-200 bg-white px-3.5 py-2 text-sm font-semibold text-purple-900 transition-all duration-200 hover:-translate-y-px hover:border-purple-300 hover:bg-purple-50 active:translate-y-0 dark:border-purple-700 dark:bg-gray-800 dark:text-purple-300 dark:hover:bg-gray-700"
        onClick={
          selectingAll
            ? () => clearSelection()
            : () => setSelectingAll(!selectingAll)
        }
      >
        {selectingAll ? (
          <>
            <XMarkIcon className="h-4 w-4 transition-transform group-hover/bulk:rotate-90" />
            محو التحديد
          </>
        ) : (
          <>
            <CheckCircleIcon className="h-4 w-4 transition-transform group-hover/bulk:scale-110" />
            تحديد جميع السجلات
            <span className="inline-flex items-center rounded-full bg-purple-100 px-1.5 py-0 text-xs font-bold tabular-nums dark:bg-purple-950/60">
              {formatNumber(totalItems)}
            </span>
          </>
        )}
      </button>
    </div>
  );
};

export default BulkSelection;
